import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable(
    {
        providedIn: 'root'
    }
)
export class GeneralService {

    httpOptions = {
        headers: new HttpHeaders()
            .set('Content-Type', 'application/json;charset=UTF-8')
            .set('Accept', 'application/json')
            .set('Access-Control-Allow-Methods', '*')
    };

    constructor(private http: HttpClient) { }
    /**
     *
     * @param url
     */
    get<T>(url: string, params?: any) {
        const urlEnd = url;
        const options = params ? { params: this.makeParams(params) } : {};

        return this.http.get<T>(urlEnd, options);
    }

    postFile<T> (url: string, body: any, params?: any) {
        const urlEnd = url;
        let options = params ? {params : this.makeParams(params)} : {};
        return this.http.post<T>(urlEnd, body, { observe: 'body', responseType: 'blob' as 'json' });
    }

    /**
     *
     * @param url
     * @param body
     */

    post<T>(url: string, body: any, params?: any) {
        let options = { withCredentials: false };
        if (params) {
            params.withCredentials = true;
            options = params;
        }
        let urlEnd = url;
        return this.http.post<T>(urlEnd,  body, options);
    }


    /**
     *
     * @param url
     * @param body
     */
    put<T>(url: string, body: any, params?: any) {
         let options = { withCredentials: false };
        if (params) {
            params.withCredentials = true;
            options = params;
        }
        let urlEnd = url;
        return this.http.put<T>(urlEnd, body);
    }

    /**
     *
     * @param url
     */
    delete(url: string) {
        let urlEnd = url
        return this.http.delete(urlEnd);
    }

    /**
     *
     * @param url
     * @param body
     */
    patch(url: string, body: any) {
        let urlEnd = url
        return this.http.patch(urlEnd, body);
    }

    /**
     *
     * @param url
     */
    head(url: string) {
        let urlEnd = url
        return this.http.head(urlEnd);
    }

    /**
     *
     * @param url
     */
    options(url: string) {
        let urlEnd = url
        return this.http.options(urlEnd);
    }

    /**
     *
     * @param fecha
     */
    fechatoString(fecha: any) {
        return fecha.year + "-" + fecha.month + "-" + fecha.day;
    }
    /**
     *
     * @param url
     */
    makeParams(params: any) {
        let httpParams = new HttpParams();
        // tslint:disable-next-line:forin
        for (const param in params) {
            httpParams = httpParams.append(param, params[param]);
        }
        return httpParams;
    }
}

export class ServiceId {
    static readonly SSO = environment.server.sso;
    static readonly DYNAMIC = environment.server.dynamic;
    static readonly DERECHOS = environment.server.derechos;
    static readonly PASSWORD = environment.server.clave;
    static readonly CONTEXT_DYNAMIC_QUERY_DE = environment.context.derechos;
    static readonly CONTEXT_DYNAMIC_QUERY_SSCH = environment.context.ssch;
}

function replaceEmptyStringsWithNull(obj: any): any {
    if (Array.isArray(obj)) {
        return obj.map(replaceEmptyStringsWithNull);
    } else if (obj !== null && typeof obj === "object") {
        const newObj: any = {};
        for (const key in obj) {
        const value = obj[key];
        if (value === "") {
            newObj[key] = null;
        } else {
            newObj[key] = replaceEmptyStringsWithNull(value);
        }
        }
        return newObj;
    }
    return obj;
}